"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLayers = void 0;
/**
 * Using this still requires you to set `layerBgSolid` on your own
 */
exports.defaultLayers = {
    layerBg: "#ffffff11",
    layerBgHighlight: "#ffffff22",
};
//# sourceMappingURL=defaultLayers.js.map